(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bts-b4-code-rename"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESDEVIN' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-b4-nav-hover"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-b4-nav-move"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-b4-nav-space"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-before-benefit-type"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-before-copy-shift"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-before-offer-redesign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-landing-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
